import { measure, type FontKey } from "./metrics";

export function ellipsize(s: string, f: FontKey, size: number, width: number, tracking = 0): string {
  s = s.trim();
  if (measure(s, f, size, tracking) <= width) return s;
  const ell = measure("…", f, size, tracking);
  let lo = 0, hi = s.length;
  while (lo < hi) {
    const mid = (lo + hi + 1) >> 1;
    if (measure(s.slice(0, mid), f, size, tracking) + ell <= width) lo = mid; else hi = mid - 1;
  }
  const cut = s.slice(0, lo).replace(/[\s,.;:·–-]+$/, "");
  return cut ? cut + "…" : "";
}

function tokens(s: string): string[] {
  const out: string[] = [];
  for (const m of s.matchAll(/[^\s\-/–]+[\-/–]?|[\-/–]/g)) out.push(m[0]);
  return out;
}

/** Greedy word wrap; the last allowed line gets an ellipsis if text remains. */
export function wrap(s: string, f: FontKey, size: number, width: number, maxLines: number, firstWidth = width): string[] {
  s = (s || "").replace(/\s+/g, " ").trim();
  if (!s || maxLines <= 0 || width <= 0) return [];
  const lines: string[] = [];
  let cur = "", i = 0;
  const words = tokens(s);
  const glue = (a: string, b: string) => (!a ? b : /[\-/–]$/.test(a) ? a + b : a + " " + b);
  const w = () => (lines.length === 0 ? firstWidth : width);
  while (i < words.length) {
    const next = glue(cur, words[i]);
    if (measure(next, f, size) <= w()) { cur = next; i++; continue; }
    if (!cur) {
      let k = words[i].length;
      while (k > 1 && measure(words[i].slice(0, k) + "-", f, size) > w()) k--;
      const hy = k >= 3 && /\p{L}$/u.test(words[i].slice(0, k));
      lines.push(words[i].slice(0, k) + (hy ? "-" : ""));
      words[i] = words[i].slice(k);
    } else { lines.push(cur); cur = ""; }
    if (lines.length === maxLines) break;
  }
  if (lines.length < maxLines && cur) { lines.push(cur); cur = ""; }
  const rest = [cur, ...words.slice(i)].filter(Boolean).reduce(glue, "");
  if (rest && lines.length) {
    const li = lines.length - 1;
    lines[li] = ellipsize(glue(lines[li], rest) + "  …", f, size, li === 0 ? firstWidth : width);
  }
  return lines.filter(Boolean);
}
